import instance from "services/api";

export const getRoutes = (params) => {
  return instance()
    .get(`/infobus/getRoutes?${params}`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getPaymentTypes = () => {
  return instance()
    .get(`/infobus/getPaymentTypes`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getYears = () => {
  return instance()
    .get(`/infobus/getYears`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getTransactionByDay = (params) => {
  return instance()
    .get(`/infobus/getTransactionByDay?${params}`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getTransactionByType = (params) => {
  return instance()
    .get(`/infobus/getTransactionByType?${params}`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getTransactionByRoute = (params) => {
  return instance()
    .get(`/infobus/getTransactionByRoute?${params}`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getTransactionByMonth = (params) => {
  return instance()
    .get(`/infobus/getTransactionByMonth?${params}`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};

export const getSentimentResourceStats = (params) => {
  return instance()
    .get(`/alem/sentimentResourceStats?${params}`)
    .then((res) => res?.data || [])
    .catch((err, data) => {
      // return handleError(err);
    });
};
